// extracted by mini-css-extract-plugin
export var inlineLink = "_b4-0";
export var inlineLinkButton = "_b4-1";